import { Routes } from '@angular/router';
import { SOFTLINE_PERMISSION_STEMPELTERMINAL } from './stempel-terminal.permissions';

export const pmsStempelTerminalRoutes: Routes = [
  {
    path: 'stempel-terminal',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/stempel-terminal.component').then((c) => c),
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/time-clock/time-clock.component').then(c => c.TimeClockComponent),
          },
          {
            path: 'uebersicht',
            loadComponent: () => import('./pages/clock-overview/clock-overview.component').then(c => c.ClockOverviewComponent)
          },
          {
            path: 'spezialstempel',
            loadComponent: () => import('./pages/custom/custom.component').then(c => c.CustomComponent),
          }
        ],
      },
    ],
    data: { permission: SOFTLINE_PERMISSION_STEMPELTERMINAL },
    providers: [],
  },
];
